module.exports = "/images/background.png?8968e62e2f01c3d6e4b2feb119db1469";